import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }

  return config;
});

export const getListeServicePagination = async (page, size) => {
  return await axios.get(
    BASE_URL(`admin/listeservices?page=${page}&size=${size}`),
    {}
  );
};

export const getListeServiceEtablissement = async () => {
  return await axios.get(
    BASE_URL(`etablissement/listeservices`),
    {}
  );
};


